import type { Workspace } from '@modules/workspaces/workspaces.type'

import type { WorkspaceSettings } from '../../settings.interface'

export function workspaceToSettings(workspace: Workspace): WorkspaceSettings {
  return {
    id: workspace.workspaceId,
    name: workspace.name,
    logo: workspace.logoUrl ?? null,
    dataResidencyRegion: workspace.region,
    createdAt: workspace.createdAt ?? workspace.created ?? '',
    projectCount: 0,
    memberCount: 0,
  }
}
